import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import GlobalStudentTask from "../../pages/common/globalstudenttask";
import STopMenu from "../topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";

export default function StudentTask() {
  const { profile } = useAuth();
  const slug = profile.id;
  console.log("slug",slug);
  const isStudent911 = profile?.role === "Student911";
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  return (
    <>
      {isStudent && <STopMenu slug={slug} activeMenu="Task" />}
      {isStudent911 && <S911TopMenu slug={slug} activeMenu="Task" />}
      {isStudent12 && <S12TopMenu slug={slug} activeMenu="Task" />}
      <GlobalStudentTask studentId={slug} type={226} isStudent={true} />
    </>
  );
}